<template>
  <v-app>
    <v-container class="fill-height" v-if="!isAuthen && loadDone">
      <login-view :login="login"></login-view>
    </v-container>
    <v-container v-else-if="loadDone">
      <main-view></main-view>
    </v-container>
    <v-container class="my-16 text-center" v-if="!loadDone">
      <v-progress-circular
        indeterminate
        color="primary"
        :size="100"
        :width="15"
      >
      </v-progress-circular>
    </v-container>
  </v-app>
</template>

<script>
import LoginView from "./views/LoginView.vue";
import MainView from "./views/MainView.vue";

var DEBUG = false;
// ENABLE/DISABLE Console Logs
if (!DEBUG) {
  console.log = function () {};
}

export default {
  name: "App",
  components: {
    LoginView,
    MainView,
  },
  data: () => ({
    isAuthen: null,
    loadDone: false,
  }),
  async created() {
    this.loadDone = false;
    await this.resetUser();
  },
  methods: {
    async login() {
      await this.$store.dispatch("login");
      this.loadDone = false;
      await this.$store.dispatch("getUser");
      this.isAuthen = this.$store.getters.isAuthenticated;
      this.loadDone = true;
    },
    async resetUser() {
      await this.$store.dispatch("resetToken");
      console.log(this.$store.getters.accessToken);
      if (this.$store.getters.accessToken != null) {
        await this.$store.dispatch("getUser");
        this.isAuthen = this.$store.getters.isAuthenticated;
        console.log(this.$store.getters.accessToken);
      }
      this.loadDone = true;
    },
  },
};
</script>
